import VPaginator from './VPaginator.vue'

module.exports = VPaginator



// WEBPACK FOOTER //
// ./src/index.js